const Dashboard_H2_1H2_2V2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 21 19" width="21" height="19" fill="none">
            <path fill="currentColor" fillRule="evenodd" d="M3.5 2C2.67 2 2 2.67 2 3.5v12c0 .83.67 1.5 1.5 1.5H6V2H3.5ZM11 17H7V2h4v15Zm1 0h5.5c.83 0 1.5-.67 1.5-1.5V10h-7v7Zm7-8V3.5c0-.83-.67-1.5-1.5-1.5H12v7h7ZM1 3.5A2.5 2.5 0 0 1 3.5 1h14A2.5 2.5 0 0 1 20 3.5v12a2.5 2.5 0 0 1-2.5 2.5h-14A2.5 2.5 0 0 1 1 15.5v-12Z"></path>
        </svg>
    )
}

export default Dashboard_H2_1H2_2V2